// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import PersonnelProfileLayout from './PersonnelProfileLayout';

import PersonnelService from '../../services/PersonnelService';

const DeletePersonnel = () => {
	const [personnel, setPersonnel] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([PersonnelService.getPersonnel(id)]).then(([personnelData]) => {
			setPersonnel(personnelData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the PersonnelService to delete the personnel
			await PersonnelService.deletePersonnel(id);

			// Redirect the user to the list of personnels
			navigate('/administration/personnel');
		} catch (error) {
			console.error(
				'Erreur lors de la suppression des informations du personnel',
				error
			);
		}
	};

	return (
		<PersonnelProfileLayout>
			{personnel && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{personnel.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement le profil de ce personnel.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez le profil de ce personnel, toutes les données
									et informations le concernant seront définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le profil de ce personnel
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</PersonnelProfileLayout>
	);
};

export default DeletePersonnel;
